import { ChevronRightIcon } from '@radix-ui/react-icons';
import * as RadixMenubar from '@radix-ui/react-menubar';
import { ReactNode } from 'react';
import './TopbarMenu.css';

type MenuItemFunction = () => void;

export interface MenuItem {
  label?: string | ReactNode;
  rightSlot?: string | ReactNode;
  onClick?: MenuItemFunction;
  items?: MenuItem[];
  separator?: boolean;
}

export const TopbarMenu = ({ data }: { data: MenuItem[] }) => {
  const renderMenuItem = (menuItem: MenuItem, index: number): ReactNode => {
    if (menuItem.separator) {
      return <RadixMenubar.Separator className="MenubarSeparator" />;
    }

    if (!menuItem.items) {
      return (
        <RadixMenubar.Item
          className="MenubarItem"
          onClick={menuItem.onClick}
          key={`menu-item-${index}`}
        >
          {menuItem.label}
          {menuItem.rightSlot && (
            <div className="RightSlot">{menuItem.rightSlot}</div>
          )}
        </RadixMenubar.Item>
      );
    } else {
      return (
        <RadixMenubar.Sub key={`sub-menu-item-${index}`}>
          <RadixMenubar.SubTrigger className="MenubarSubTrigger">
            {menuItem.label}
            <div className="RightSlot">
              <ChevronRightIcon />
            </div>
          </RadixMenubar.SubTrigger>
          <RadixMenubar.SubContent
            className="MenubarSubContent"
            alignOffset={-5}
          >
            {menuItem.items.map((subMenuItem, subIndex) =>
              renderMenuItem(subMenuItem, subIndex)
            )}
          </RadixMenubar.SubContent>
        </RadixMenubar.Sub>
      );
    }
  };

  return (
    <RadixMenubar.Root className="MenubarRoot">
      {data.map((menuRootItem, rootItemIndex) => (
        <RadixMenubar.Menu key={`menu-root-${rootItemIndex}`}>
          <RadixMenubar.Trigger className="MenubarTrigger">
            {menuRootItem.label}
          </RadixMenubar.Trigger>
          <RadixMenubar.Portal>
            <RadixMenubar.Content
              key={`menu-content-${rootItemIndex}`}
              className="MenubarContent"
              align="start"
              sideOffset={5}
              alignOffset={-3}
            >
              {menuRootItem?.items?.map((menuItem, itemIndex) =>
                renderMenuItem(menuItem, itemIndex)
              )}
            </RadixMenubar.Content>
          </RadixMenubar.Portal>
        </RadixMenubar.Menu>
      ))}
    </RadixMenubar.Root>
  );
};

export default TopbarMenu;
